import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import InterviewPapersPage from '../../features/interview/components/InterviewPapersPage';

const InterviewPapersPageRoute = () => (
  <ProtectedRoute requiresAuth={true}>
    <InterviewPapersPage />
  </ProtectedRoute>
);

export default InterviewPapersPageRoute;
